import {
  backendURL,
} from '../config';
import axios from 'axios';
// import axiosRetry from 'axios-retry';

const TOKEN_KEY = 'techproone_token';
const USER_KEY = 'techproone_user';

const isInvalidTokenError = (error) => {
  const msg = error?.response?.data?.message;
  if (typeof msg === 'string' && msg.toLowerCase().includes('token is not valid')) {
    return true;
  }
  return error?.response?.status === 401;
};

let isHandlingInvalidToken = false;
const handleInvalidToken = () => {
  if (isHandlingInvalidToken) return;
  isHandlingInvalidToken = true;
  try {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  } catch (_) {}
  if (typeof window !== 'undefined' && window.location.pathname !== '/') {
    window.location.replace('/');
  }
};

// axiosRetry(axios, {
//   retries: 5, // number of retries
//   retryDelay: axiosRetry.exponentialDelay,
//   retryCondition: (error) => {
//       // if retry condition is not specified, by default idempotent requests are retried
//       return error?.response?.status === 503;
//   },
// });
export const headerJson = () => {
  const token = localStorage.getItem("techproone_token");
  return {
    "Content-Type": "application/json",
    Authorization: `bearer ${token}`,
    "x-access-token": token,
  };
};

export function headerFormData() {
  const token = localStorage.getItem("techproone_token");
  return {
    "Content-Type": "multipart/form-data",
    Authorization: `bearer ${token}`,
    "x-access-token": token,
  };
}
// When the backend is restarting / unreachable the gateway (nginx) returns
// HTML like "502 Bad Gateway". Surface a friendly message instead of letting
// that raw HTML reach a toast.
const friendlyErrorPayload = (error) => {
  const raw = error?.response?.data;
  const status = error?.response?.status;
  if (status === 429) {
    return { message: 'You\'re moving fast — please slow down for a moment.' };
  }
  if (typeof raw === 'string' && /<html|<!doctype/i.test(raw)) {
    if (status === 502 || status === 503 || status === 504) {
      return { message: 'The server is temporarily unavailable. Please try again in a moment.' };
    }
    return { message: 'Network error. Please try again.' };
  }
  if (raw === undefined && error?.message) {
    return { message: error.message };
  }
  return raw;
};

// `props` accepts an optional `signal` (AbortSignal). When passed,
// the underlying axios request is cancelled on abort and the promise
// rejects with `{ aborted: true }` so callers can ignore it cleanly.
// Existing callsites that don't pass `signal` keep working unchanged.
export const fetchAPIFrom = (uri, data, props = {}, method) => {
  return new Promise((resolve, reject) => {
    const { signal, ...rest } = props || {};
    const axiosConfig = signal ? { ...rest, signal } : rest;
    axios[method](`${backendURL}/${uri}`, data, axiosConfig).then((response) => {
      resolve(response.data);
    }).catch(error => {
      if (axios.isCancel?.(error) || error?.code === 'ERR_CANCELED') {
        return reject({ aborted: true, message: 'Request cancelled' });
      }
      console.log('fetchAPIFrom', error);
      if (isInvalidTokenError(error)) {
        handleInvalidToken();
      }
      reject(friendlyErrorPayload(error));
    });
  });
};

export const fetchAPI = async (uri) => {
  const res = await fetch(`${backendURL}/${uri}`, {next: {revalidate: 5}});
  return await res.json();
};



export async function convertImageUrlToBase64(url) {
  const response = await fetch(url);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
          resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
  });
}

export const getDateTimeString = (date) =>
  `${date.toLocaleDateString()} ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;

export const getTimeZone = () => {
  const e = String(-new Date().getTimezoneOffset() / 60);
  return e.includes('-') ? e : '+'.concat(e);
};

export function convertMinutesToHoursAndMinutes(totalMinutes) {
  // Calculate hours and remaining minutes
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:00`;
}

export function convertHtmlToText(html) {
  const parser = new DOMParser();
  let description_without_html = parser.parseFromString(html, 'text/html')
  const textContent = description_without_html?.body?.textContent || html;

  return textContent
}